// components/CTASection.jsx — Full-width CTA banner

import { Button } from "./UI";

export default function CTASection({ content, dark, lang }) {
  const isEs = lang === "es";
  const title      = isEs ? (content.titleEs      || content.title)      : content.title;
  const subtitle   = isEs ? (content.subtitleEs   || content.subtitle)   : content.subtitle;
  const buttonText = isEs ? (content.buttonTextEs || content.buttonText) : content.buttonText;

  return (
    <section className="py-20 px-4 relative overflow-hidden bg-[#0F172A]">
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-[#A3E635]/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-[#A3E635]/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#A3E635]/40 to-transparent" />

      <div className="max-w-3xl mx-auto text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight">
          {title}
        </h2>
        <p className="text-white/55 text-base sm:text-lg mb-10">{subtitle}</p>
        <a href={content.link}>
          <Button size="xl" className="shadow-2xl shadow-[#A3E635]/30">{buttonText}</Button>
        </a>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#A3E635]/40 to-transparent" />
    </section>
  );
}
